
import React from 'react';

interface UnsplashLocation {
  title?: string;
  name?: string;
  city?: string;
  country?: string;
}

interface UnsplashAttributionProps {
  photographerName: string;
  photographerUrl: string;
  location?: UnsplashLocation;
}

const UnsplashAttribution: React.FC<UnsplashAttributionProps> = ({
  photographerName,
  photographerUrl,
  location
}) => {
  // Determine the best location string to display based on available data
  const getLocationString = () => {
    if (!location) return null;
    
    // Check in priority order: title, name, city, country
    return location.title || location.name || location.city || location.country;
  };
  
  const locationString = getLocationString();
  
  const textStyle = {
    color: 'rgba(255, 255, 255, 0.8)',
    fontSize: '12px',
    textShadow: '0px 1px 3px rgba(0, 0, 0, 0.5)',
    zIndex: 10
  };

  return (
    <div className="absolute bottom-3 left-3 flex flex-col">
      {/* Location information - only shown if available */}
      {locationString && (
        <div 
          className="mb-1 text-xs"
          style={textStyle}
        >
          Location: {locationString}
        </div>
      )}
      
      {/* Photo attribution */}
      <div
        className="text-xs"
        style={textStyle}
      >
        Photo by{' '}
        <a
          href={photographerUrl}
          target="_blank"
          rel="noopener noreferrer"
          className="underline hover:text-white transition-colors"
        >
          {photographerName}
        </a>{' '}
        on{' '}
        <a
          href="https://unsplash.com"
          target="_blank"
          rel="noopener noreferrer"
          className="underline hover:text-white transition-colors"
        >
          Unsplash
        </a>
      </div>
    </div>
  );
};

export default UnsplashAttribution;
